import { handleActions } from 'redux-actions'
import { SET_LOAD_STATE, SET_USER, SET_LOGIN_STATE } from './constants'

export const initialState = {
  loading: false,
  isLogin: false,
  userData: {}
}

const appReducer = handleActions(
  {
    [SET_USER]: (state, action) => {
      return {
        ...state,
        userData: action.payload
      }
    },
    [SET_LOAD_STATE]: (state, action) => {
      return {
        ...state,
        loading: action.payload.status
      }
    },
    [SET_LOGIN_STATE]: (state, action) => {
      return {
        ...state,
        isLogin: action.payload.state
      }
    }
  },
  initialState
)

export default appReducer
